import { useQuery } from '@apollo/client/react';
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';

import { ProcessorInstancesTable } from '#components/processor-instances-table';
import { GET_PROCESSOR_INSTANCES } from '#graphql/queries/processor-instances-list';

export function ProcessorInstancesListPage() {
  const { data, loading, error, refetch } = useQuery(GET_PROCESSOR_INSTANCES, {
    variables: { limit: 200 },
  });

  const rows = data?.processorInstances ?? [];

  if (loading && !data) {
    return (
      <Box p={4}>
        <Heading size="lg" color="fg" mb={6}>
          Processor instances
        </Heading>
        <Text>Loading…</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4}>
        <Heading size="lg" color="fg" mb={6}>
          Processor instances
        </Heading>
        <Text color="red.500">Error loading instances: {error.message}</Text>
        <Button onClick={() => void refetch()} mt={4}>
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <Box p={4}>
      <VStack gap={6} align="stretch">
        <Box>
          <Heading size="lg" color="fg" mb={1}>
            Processor instances
          </Heading>
          <Text fontSize="sm" color="fg.muted">
            Your recent processor runs (newest first). At most 200 shown.
          </Text>
        </Box>

        <ProcessorInstancesTable
          rows={rows}
          loading={loading}
          showProcessorColumn
        />
      </VStack>
    </Box>
  );
}
